import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { ChartDoughnut, FooterReport, Gap, GridInline, LabelTitle, Line, ProgressBar } from "../../../../components/Global";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageThree from "./PageThree";
import LoadingPage from "./LoadingPage";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const PageTwo = ({
    idJadwalCbt,
    idKelas,
    kodeTahunAjaran,
    schoolName,
    kuotaPariwisata,
    kuotaBisnisDanManajemen,
    kuotaSeniDanEkonomiKreatif,
    kuotaAgribisnisDanAgriteknologi,
    kuotaKemaritiman,
    kuotaKesehatanDanPekerjaanSosial,
    kuotaTeknologiInformasi,
    kuotaTeknologiManufakturDanRekayasa,
    kuotaTeknologiKonstruksiDanProperti,
    kuotaEnergiDanPertambangan,
}) => {
    const [fetching, setFetching] = useState(false);
    const [dataDetailPsi, SetDataDetailPsi] = useState([]);
    const [detailLs, SetDetailLs] = useState([]);
    const [dataRataPencapaianKognitif, SetRataPencapaianKognitif] = useState([]);
    const [dataAq, SetDataAq] = useState([]);
    const [dataEq, SetDataEq] = useState([]);
    const [dataAm, SetDataAm] = useState([]);
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_TWO, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .catch(function (error) {
                    console.error("Error Response Page Two", error);
                });

            if (response) {
                if (response.data.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Two ", responseAPI);
                    console.log("====================================");

                    SetDetailLs(responseAPI.detailLs);
                    SetDataDetailPsi(responseAPI.detailPsi);
                    SetRataPencapaianKognitif(responseAPI.rataPencapaianKognitif);
                    SetDataAq(responseAPI.detailPsi[0]);
                    SetDataAm(responseAPI.detailPsi[1]);
                    SetDataEq(responseAPI.detailPsi[2]);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    const options = {
        responsive: true,
        legend: {
            display: false,
            position: "bottom",
            labels: {
                fontSize: 14,
                fontColor: "#616469",
                fontFamily: "Calibri",
            },
        },
        plugins: {
            datalabels: {
                display: false,
                formatter: (value) => {
                    return value + "%";
                },
                color: "#fff",
                font: {
                    size: 9,
                    weight: "bold",
                },
            },
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    const labels = ["Adversity Qoutient", "Achievement Motivation", "Emotional Qoutient"];

    let data = {
        labels,
        datasets: [
            {
                label: dataAq.keterangan,
                data: [dataAq.prosentaseBawah, dataEq.prosentaseBawah, dataAm.prosentaseBawah],
                backgroundColor: "#C4161C",
            },
            {
                label: dataEq.keterangan,
                data: [dataAq.prosentaseTengah, dataEq.prosentaseTengah, dataAm.prosentaseTengah],
                backgroundColor: "#FB8500",
            },
            {
                label: dataAm.keterangan,
                data: [dataAq.prosentaseAtas, dataEq.prosentaseAtas, dataAm.prosentaseAtas],
                backgroundColor: "#457B9D",
            },
            // {
            //     label: "test1",
            //     data: chartData,
            //     backgroundColor: chartColor,
            // },
        ],
    };

    require("../Pemetaan.css");
    return (
        <div>
            <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={schoolName} size={18} bolder={700} color={"#fff"} />
                        </GridInline>

                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div>
                <Gap height={20} />
                <div className="section-three">
                    <div className="result">
                        <LabelTitle label={"Hasil Asesmen Learning Style"} size={18} bolder={700} color={"#212529"} />
                        <Gap height={20} />
                        <div className="rekap-table">
                            <GridInline width={"40%"} verticalAlign={"top"} paddingTop={50}>
                                <ChartDoughnut
                                    valueChart={[detailLs.auditori, detailLs.visual, detailLs.kinestetik]}
                                    chartColor={["#C4161C", "#1D3557", "#FB8500"]}
                                    chartLabel={["Auditori", "Visual", "Kinestetik"]}
                                    // legend={false}
                                    datalabels={false}
                                />
                            </GridInline>
                            <GridInline width={"60%"}>
                                <LabelTitle label={"Keterangan :"} size={17} bolder={600} color={"#495057"} />
                                <Gap height={10} />
                                <GridInline width={"20%"}>
                                    <LabelTitle label={"Auditori"} size={13} bolder={400} color={"#616469"} />
                                    <Gap height={5} />
                                    <LabelTitle label={detailLs.auditori + " Siswa"} size={13} bolder={400} color={"#616469"} />
                                </GridInline>
                                <GridInline width={"20%"}>
                                    <LabelTitle label={"Visual"} size={13} bolder={400} color={"#616469"} />
                                    <Gap height={5} />
                                    <LabelTitle label={detailLs.visual + " Siswa"} size={13} bolder={400} color={"#616469"} />
                                </GridInline>
                                <GridInline width={"20%"}>
                                    <LabelTitle label={"Kinestetik"} size={13} bolder={400} color={"#616469"} />
                                    <Gap height={5} />
                                    <LabelTitle label={detailLs.kinestetik + " Siswa"} size={13} bolder={400} color={"#616469"} />
                                </GridInline>
                                <Gap height={15} />
                                <LabelTitle label={"Saran Pengelolaan Kelas :"} size={17} bolder={600} color={"#495057"} />
                                <Gap height={10} />
                                <LabelTitle label={"Visual"} size={13} bolder={600} color={"#495057"} />
                                <Gap height={5} />
                                <LabelTitle
                                    label={
                                        "Ajarkan siswa siswi anda menggunakan mind map (peta konsep) dengan berbagai warna,karena siswa dengan kemampuan visual mudah mengingat dan memahami materi pada mind map dengan warna yang bervariasi. Jika memungkinkan, putarkan video pembelajaran"
                                    }
                                    size={13}
                                    bolder={400}
                                    color={"#616469"}
                                />
                                <Gap height={10} />
                                <LabelTitle label={"Auditori"} size={13} bolder={600} color={"#495057"} />
                                <Gap height={5} />
                                <LabelTitle
                                    label={
                                        "Ajak siswa untuk aktif dalam diskusi. Biarkan siswa membaca materi pelajaran dengan keras karena mereka akan lebih cepat memahami materi jika membaca sambal mendengarkan apa yang dibaca. Jika siswa tidak mencatat di kelas, jangan terburu-buru memarahi, karena siswa dengan tipe auditory akan menangkap materi dengan cara mendengarkan."
                                    }
                                    size={13}
                                    bolder={400}
                                    color={"#616469"}
                                />
                                <Gap height={10} />
                                <LabelTitle label={"Kinestetik"} size={13} bolder={600} color={"#495057"} />
                                <Gap height={5} />
                                <LabelTitle label={"Ajaklah siswa untuk lebih banyak melakukan praktikum. Berikan ‘ice breaking’ setelah 20 atau 30 menit belajar."} size={13} bolder={400} color={"#616469"} />
                            </GridInline>
                            <Gap height={10} />
                            <Line color={"#E9ECEF"} />
                            <Gap height={10} />
                            <div>
                                <LabelTitle label={"Rata-Rata Pencapaian Kognitif Mata Pelajaran"} size={18} bolder={700} color={"#212529"} />
                                <Gap height={10} />
                            </div>
                            {dataRataPencapaianKognitif.map((rataKognitif, i) => {
                                return (
                                    <div key={i}>
                                        <GridInline width={"20%"}>
                                            <LabelTitle label={rataKognitif.namaMataPelajaran} size={13} bolder={500} color={"#616469"} />
                                        </GridInline>
                                        <GridInline width={"70%"} marginBottom="-1%">
                                            <ProgressBar progressColor={"#FB8500"} progressValue={rataKognitif.totalSkor} heightBar={15} />
                                        </GridInline>
                                        <GridInline width={"10%"} paddingLeft={25}>
                                            <LabelTitle label={rataKognitif.totalSkor} size={13} bolder={500} color={"#616469"} />
                                        </GridInline>
                                        <Gap height={10} />
                                    </div>
                                );
                            })}
                            <Line color={"#E9ECEF"} />
                            <Gap height={10} />
                            <LabelTitle label={"Rata-Rata Hasil Psychology Potential"} size={18} bolder={700} color={"#212529"} />
                            <GridInline width={"55%"}>
                                {/* <ChartStackedBar
                            legend={false}
                            valueChart={([100, 50, 30], [100, 50, 30])}
                            chartLabel={["AQ", "EQ", "AM"]}
                            chartColor={[
                                "#C4161C",
                                "#1D3557",
                                "#FB8500",
                            ]}
                        /> */}
                                <Bar data={data} options={options} />
                            </GridInline>
                            <GridInline width={"45%"} verticalAlign={"top"} paddingTop={50} paddingLeft={30}>
                                <LabelTitle label={"Adversity Qoutient"} size={17} bolder={500} color={"#212529"} />
                                <GridInline width={"100%"}>
                                    <GridInline width={"33%"}>
                                        <div
                                            style={{
                                                display: "inline-block",
                                                width: "10%",
                                                backgroundColor: "#457B9D",
                                                height: 15,
                                                paddingBottom: 11,
                                            }}
                                        >
                                            &nbsp;
                                        </div>
                                        <GridInline width={"90%"} paddingLeft={"5%"}>
                                            <LabelTitle label={"Rata-Rata Atas " + dataAq.prosentaseAtas + "%"} size={16} bolder={500} color={"#212529"} />
                                        </GridInline>
                                    </GridInline>
                                    <GridInline width={"33%"}>
                                        <div
                                            style={{
                                                display: "inline-block",
                                                width: "10%",
                                                backgroundColor: "#FB8500",
                                                height: 15,
                                                paddingBottom: 11,
                                            }}
                                        >
                                            &nbsp;
                                        </div>
                                        <GridInline width={"90%"} paddingLeft={"5%"}>
                                            <LabelTitle label={"Rata-Rata " + dataAq.prosentaseTengah + "%"} size={16} bolder={500} color={"#212529"} />
                                        </GridInline>
                                    </GridInline>
                                    <GridInline width={"33%"}>
                                        <div
                                            style={{
                                                display: "inline-block",
                                                width: "10%",
                                                backgroundColor: "#C4161C",
                                                height: 15,
                                                paddingBottom: 11,
                                            }}
                                        >
                                            &nbsp;
                                        </div>
                                        <GridInline width={"90%"} paddingLeft={"5%"}>
                                            <LabelTitle label={"Rata-Rata Bawah " + dataAq.prosentaseBawah + "%"} size={16} bolder={500} color={"#212529"} />
                                        </GridInline>
                                    </GridInline>
                                </GridInline>
                                <Gap height={20} />
                                <LabelTitle label={"Emotional Qoutient"} size={17} bolder={500} color={"#212529"} />
                                <GridInline width={"100%"}>
                                    <GridInline width={"33%"}>
                                        <div
                                            style={{
                                                display: "inline-block",
                                                width: "10%",
                                                backgroundColor: "#457B9D",
                                                height: 15,
                                                paddingBottom: 11,
                                            }}
                                        >
                                            &nbsp;
                                        </div>
                                        <GridInline width={"90%"} paddingLeft={"5%"}>
                                            <LabelTitle label={"Rata-Rata Atas " + dataEq.prosentaseAtas + "%"} size={16} bolder={500} color={"#212529"} />
                                        </GridInline>
                                    </GridInline>
                                    <GridInline width={"33%"}>
                                        <div
                                            style={{
                                                display: "inline-block",
                                                width: "10%",
                                                backgroundColor: "#FB8500",
                                                height: 15,
                                                paddingBottom: 11,
                                            }}
                                        >
                                            &nbsp;
                                        </div>
                                        <GridInline width={"90%"} paddingLeft={"5%"}>
                                            <LabelTitle label={"Rata-Rata " + dataEq.prosentaseTengah + "%"} size={16} bolder={500} color={"#212529"} />
                                        </GridInline>
                                    </GridInline>
                                    <GridInline width={"33%"}>
                                        <div
                                            style={{
                                                display: "inline-block",
                                                width: "10%",
                                                backgroundColor: "#C4161C",
                                                height: 15,
                                                paddingBottom: 11,
                                            }}
                                        >
                                            &nbsp;
                                        </div>
                                        <GridInline width={"90%"} paddingLeft={"5%"}>
                                            <LabelTitle label={"Rata-Rata Bawah " + dataEq.prosentaseBawah + "%"} size={16} bolder={500} color={"#212529"} />
                                        </GridInline>
                                    </GridInline>
                                </GridInline>
                                <Gap height={20} />
                                <LabelTitle label={"Achievement Motivation"} size={17} bolder={500} color={"#212529"} />
                                <GridInline width={"100%"}>
                                    <GridInline width={"33%"}>
                                        <div
                                            style={{
                                                display: "inline-block",
                                                width: "10%",
                                                backgroundColor: "#457B9D",
                                                height: 15,
                                                paddingBottom: 11,
                                            }}
                                        >
                                            &nbsp;
                                        </div>
                                        <GridInline width={"90%"} paddingLeft={"5%"}>
                                            <LabelTitle label={"Rata-Rata Atas " + dataAm.prosentaseAtas + "%"} size={16} bolder={500} color={"#212529"} />
                                        </GridInline>
                                    </GridInline>
                                    <GridInline width={"33%"}>
                                        <div
                                            style={{
                                                display: "inline-block",
                                                width: "10%",
                                                backgroundColor: "#FB8500",
                                                height: 15,
                                                paddingBottom: 11,
                                            }}
                                        >
                                            &nbsp;
                                        </div>
                                        <GridInline width={"90%"} paddingLeft={"5%"}>
                                            <LabelTitle label={"Rata-Rata " + dataAm.prosentaseTengah + "%"} size={16} bolder={500} color={"#212529"} />
                                        </GridInline>
                                    </GridInline>
                                    <GridInline width={"33%"}>
                                        <div
                                            style={{
                                                display: "inline-block",
                                                width: "10%",
                                                backgroundColor: "#C4161C",
                                                height: 15,
                                                paddingBottom: 11,
                                            }}
                                        >
                                            &nbsp;
                                        </div>
                                        <GridInline width={"90%"} paddingLeft={"5%"}>
                                            <LabelTitle label={"Rata-Rata Bawah " + dataAm.prosentaseBawah + "%"} size={16} bolder={500} color={"#212529"} />
                                        </GridInline>
                                    </GridInline>
                                </GridInline>
                            </GridInline>
                        </div>
                    </div>
                </div>
                {/* <Gap height={40} />
                <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div> */}
            </div>

            {openPage ? (
                <PageThree
                    idJadwalCbt={idJadwalCbt}
                    idKelas={idKelas}
                    kodeTahunAjaran={kodeTahunAjaran}
                    schoolName={schoolName}
                    kuotaPariwisata={kuotaPariwisata}
                    kuotaBisnisDanManajemen={kuotaBisnisDanManajemen}
                    kuotaSeniDanEkonomiKreatif={kuotaSeniDanEkonomiKreatif}
                    kuotaAgribisnisDanAgriteknologi={kuotaAgribisnisDanAgriteknologi}
                    kuotaKemaritiman={kuotaKemaritiman}
                    kuotaKesehatanDanPekerjaanSosial={kuotaKesehatanDanPekerjaanSosial}
                    kuotaTeknologiInformasi={kuotaTeknologiInformasi}
                    kuotaTeknologiManufakturDanRekayasa={kuotaTeknologiManufakturDanRekayasa}
                    kuotaTeknologiKonstruksiDanProperti={kuotaTeknologiKonstruksiDanProperti}
                    kuotaEnergiDanPertambangan={kuotaEnergiDanPertambangan}
                />
            ) : (
                <LoadingPage />
            )}
        </div>
    );
};

export default PageTwo;
